import { graphql } from '@/gql'

export const COMPANY_RECRUITER_DETAIL_FRAGMENT = graphql(/* GraphQL */ `
  fragment CompanyRecruiterDetailFragment on CompanyRecruiter {
    id
    status
    email
    recruiterFee
    recruiterOwnershipDays
    recruiterOwnershipDaysLeft
    recruiterManagesWorkers
    hasHires
    externalIdentifier
    invitedAt
    requiredCustomFieldsComplete
    onboardingStatus
    customFieldValues {
      ...CustomFieldValuesView
      ...FieldableFormCustomFieldValue
    }
    tags {
      id
      name
    }
    recruiter {
      id
      name
      avatar
      initials
      market {
        code
        name
      }
      availableMarkets {
        market {
          code
          name
          regionLabel
        }
        regions {
          id
          name
        }
      }
      owner {
        id
        name
      }
    }
    company {
      id
      name
    }
    notes(first: 1) {
      paginatorInfo {
        total
      }
    }
  }
`)

export const COMPLIANCE_ROW_FRAGMENT = graphql(/* GraphQL */ `
  fragment ComplianceRowFragment on Compliance {
    name
    applicable
    completed
    completedAt
    title
    description
    data {
      ... on ComplianceDataFile {
        title
        file {
          id
          name
          url
          createdAt
        }
      }
      ... on ComplianceDataField {
        label
        value
      }
      ... on ComplianceDataBusinessEntity {
        businessEntity {
          id
          localisedName
          companyName
          companyNumber
          taxNumber
        }
      }
    }
  }
`)

export const COMPANY_RECRUITER_NOTES_FRAGMENT = graphql(/* GraphQL */ `
  fragment CompanyRecruiterNotesFragment on CompanyRecruiter {
    id
    notes(first: 100) {
      data {
        ...NoteViewFragment
      }
      paginatorInfo {
        total
      }
    }
  }
`)
